import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import {AuthorizedContext} from "../../../context/AuthorizedContext";
import {Typography} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: 0
        },
        actions: {
            display: "flex",
            justifyContent: "flex-end"
        }

    }),
);


const UserInfoCard = () => {

    const {credentials} = React.useContext(AuthorizedContext);
    const classes = useStyles();

    const {email, firstName, lastName} = credentials;

    const [userName] = React.useState(getUserName());
    const [userInitials] = React.useState(getUserInitials());


    function getUserName() {
        const userFirstName = firstName ? firstName : "";
        const userLastName = lastName ? lastName : "";
        return userFirstName + " " + userLastName;
    }

    function getUserInitials() {
        const userFirstName = firstName ? firstName[0] : "";
        const userLastName = lastName ? lastName[0] : "";
        return userFirstName + userLastName;
    }

    return (
        <Card className={classes.card}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe" color="primary">
                        {userInitials}
                    </Avatar>
                }
                title={userName}
                subheader={<Typography variant="caption">{email}</Typography>}
            />
        </Card>
    );
};

export default UserInfoCard;